import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JuiButton } from '@jump-tech-frontend/core-components-angular';

export interface PhotoSourceCopy {
  readonly takePhoto: string;
  readonly photosAndFiles: string;
  readonly cancel: string;
}

export const PHOTO_SOURCE_CAMERA = 'camera';
export const PHOTO_SOURCE_FILES = 'files';
export const PHOTO_SOURCE_CANCELLED = 'cancelled';

@Component({
  selector: 'crds-photo-source-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [JuiButton],
  template: `
    <div class="photo-source">
      <jui-button size="lg" expand (click)="takePhoto()" data-qa="photoSourceCamera">
        {{ copy.takePhoto }}
        <span slot="icon" class="material-icons" aria-hidden="true">photo_camera</span>
      </jui-button>
      <jui-button size="lg" expand display="ghost" (click)="openFiles()" data-qa="photoSourceFiles">
        {{ copy.photosAndFiles }}
        <span slot="icon" class="material-icons" aria-hidden="true">photo_library</span>
      </jui-button>
      <jui-button size="lg" expand display="ghost" color="secondary" (click)="cancel()" data-qa="photoSourceCancel">
        {{ copy.cancel }}
      </jui-button>
    </div>
  `,
  styles: [
    `
      .photo-source {
        display: flex;
        flex-direction: column;
        gap: var(--jds-space-sm);
        padding: var(--jds-space);
      }
    `
  ]
})
export class PhotoSourceModalComponent {
  @Input() copy!: PhotoSourceCopy;
  @Input() chooseFile: () => void = () => undefined;

  private readonly activeModal = inject(NgbActiveModal);

  protected takePhoto(): void {
    this.activeModal.close(PHOTO_SOURCE_CAMERA);
  }

  protected openFiles(): void {
    this.activeModal.dismiss(PHOTO_SOURCE_FILES);
    this.chooseFile();
  }

  protected cancel(): void {
    this.activeModal.dismiss(PHOTO_SOURCE_CANCELLED);
  }
}
